$(function () {
  // ------------------------------
  // 質問 表示制御
  // ------------------------------
  // 初期表示時 選択肢エリアの表示切り替え
  $('.select-question-type').each(function(i, e) {
    if (e.value == 'text' || e.value == 'image' || !(e.value)) {
      $(this).closest(".field").find('.question-items-form-group').hide();
    }
  });
  // 質問タイプ変更時 選択肢エリアの表示切り替え
  $(document).on('change', '.select-question-type', function(){
    var selection = $(this).val();
    var questionItemsFormGroup = $(this).closest(".field").find('.question-items-form-group')
    if (selection == 'text' || selection == 'image' || !selection) {
      questionItemsFormGroup.hide();
    } else {
      questionItemsFormGroup.show();
    }
  });

  // ------------------------------
  // 選択肢 表示制御
  // ------------------------------
  // 初期表示時 inputサイズ調整
  $('.select-question-item-type').each(function(i, e) {
    if (e.value != 'text') {
      $(this).closest(".form-group").find('.question-items-optional-text-form').hide();
      $(this).closest(".form-group").find('.question-items-label-form').addClass('col-sm-7');
    }
  });
  // 選択肢タイプ変更時 inputサイズ調整, 表示切り替え
  $(document).on('change', '.select-question-item-type', function() {
    var selection = $(this).val();
    var questionItemsValueForm = $(this).closest(".form-group").find('.question-items-optional-text-form')
    var questionItemsLabelForm = $(this).closest(".form-group").find('.question-items-label-form')
    if (selection == 'text') {
      questionItemsValueForm.show();
      questionItemsLabelForm.removeClass('col-sm-7');
      questionItemsLabelForm.addClass('col-sm-3');
    } else {
      questionItemsValueForm.hide();
      questionItemsValueForm.children().val(null);
      questionItemsLabelForm.removeClass('col-sm-3');
      questionItemsLabelForm.addClass('col-sm-7');
    }
  });

  // ------------------------------
  // 並び替え
  // ------------------------------
  /**
   * Sortable設定
   * @param object (Element object) 並び替え範囲のオブジェクト
   */
  function setSortable(target) {
    Sortable.create(target, {
      animation: 100,
      handle:'.handle',
      onEnd: function (e) {
        $(target).children('.nested-fields').each(function (i, el) {
          $(el).find('.order').val(i+1);
        });
      }
    })
  }

  /**
   * 各要素に順番を設定
   * @param object (jQuery object) 並び替え範囲のオブジェクト
   */
  function setOrder($target) {
    $target.children('.nested-fields').each(function (i, el) {
        $(el).find('.order').val(i+1);
    });
  }

  /**
   * 各要素に順番を設定
   * @param object (MutationRecord object) MutationObserverのコールバック関数のオブジェクト
   * @param object (jQuery object) 質問の並び替え範囲のオブジェクト
   */
  function newQuestionSetting(mutationRecords, $parent) {
    for (let record of mutationRecords) {
      for (let node of record.addedNodes) {
        if ($(node).parent().is( $parent )) {
          // 新規追加時のみmutationRecordsの対象が１件（並び替え時は２件）
          let isNewQuestion = mutationRecords.length === 1;
          if (isNewQuestion) {
            // 新規質問の選択肢 Sortable設定
            let questionItemField = $(node).find('.js-medical_question_item_field')[0];
            setSortable(questionItemField);
          }
        }
      }
    }
  }

  // 質問
  let questionField = $('#js-medical_question_field')[0];
  if (questionField) {
    // 初期設定
    setSortable(questionField);
    // 追加時の監視
    let questionObserver = new MutationObserver(mutationRecords => {
      newQuestionSetting(mutationRecords, $(questionField));
      setOrder($(questionField));
    });
    questionObserver.observe(questionField, {childList: true, subtree: true});
  }

  // 選択肢
  let $questionItemFields = $('.js-medical_question_item_field');
  $questionItemFields.each(function (i, questionItemField) {
    if (questionItemField) {
      // 初期設定
      setSortable(questionItemField);
      // 追加時の監視
      let questionItemObserver = new MutationObserver( () => {
        setOrder($(questionItemField))
      });
      questionItemObserver.observe(questionItemField, {childList: true, subtree: true});
    }
  })
});
